import parseNumber from 'libphonenumber-js';

/**
 * Formats a phone number for display purposes.
 * For example, it will format:
 *
 * 16041234567 as (604) 123-4567.
 * +16041234567 as (604) 123-4567.
 *
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  const sanitizedPhoneNumber = phoneNumber.trim().replace(/[+\-() ]/g, '');

  // libphonenumber-js requires the calling code "+" to be present in the number.
  const parsedPhoneNumber = parseNumber(`+${sanitizedPhoneNumber}`);

  if (!parsedPhoneNumber) {
    // This should never happen, it means the number is malformed on the user.
    // Use the sanitized number in this case.
    return sanitizedPhoneNumber;
  }

  return parsedPhoneNumber.formatNational();
};
